import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DentalReferralFormComponent } from '../app/dental-referral-form/dental-referral-form.component';
import { NavigationLayoutComponent } from './common/navigation-layout/navigation-layout.component';
import { DcoAdminComponent } from './admin/dco-admin/dco-admin.component';
import { UserAdminComponent } from './admin/user-admin/user-admin.component';
import { ResolutionCenterComponent } from './resolution-center/resolution-center.component';
import { DcoReferralsComponent } from './dco-referrals/dco-referrals.component';
import { ListAdminComponent } from './admin/list-admin/list-admin.component';
import { LoginComponent } from './auth/login/login.component';
import { AuthGuard } from './auth/guards/auth.guard';
import { RoleGuard } from './auth/guards/role.guard';
import { ROUTE_META } from './common/route-meta';
import { AccessDeniedComponent } from './auth/access-denied/access-denied.component';

const dynamicChildRoutes: Routes = ROUTE_META.map(meta => ({
  path: meta.route.replace('/', ''), // Angular paths shouldn't start with '/'
  component: meta.component,
  canActivate: [RoleGuard],
  data: {
    title: meta.title,
    roles: meta.roles
  }
}));

const routes: Routes = [
  // Public route: Login page
  { path: 'login', component: LoginComponent, data: { title: 'CareOregon - Dental Referrals - Login', data: { roles: ['*'] } } },

  { path: 'access-denied', component: AccessDeniedComponent, data: { title: 'Access Denied - Dental Bidirectional', data: { roles: ['*'] } } },

  // Protected routes
  {
    path: '',
    component: NavigationLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'formAdmin', pathMatch: 'full' },
      ...dynamicChildRoutes
    ]
  },

  // Standalone dental referral form (protected too)
  {
    path: 'dental-referral-form',
    component: DentalReferralFormComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: {
      title: 'CareOregon - Dental Referrals',
      roles: ['SuperAdmin', 'SystemAdmin', 'ProviderUser']
    }
  },

  // Wildcard: anything unknown → login
  { path: '**', redirectTo: 'login', data: { roles: ['*'] } }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
